[
  {
    "id": 1,
    "characterization": "Staffing",
    "blurb": "Staffing challenges are affecting operational consistency and coverage."
  },
  {
    "id": 2,
    "characterization": "Measure & Manage Performance",
    "blurb": "Performance measurement and management need stronger visibility and accountability."
  },
  {
    "id": 3,
    "characterization": "Workflow",
    "blurb": "Workflow challenges are impacting day-to-day operations."
  },
  {
    "id": 4,
    "characterization": "Scientific & Microbiology Standards",
    "blurb": "Alignment to current microbiology guidelines and regulatory standards needs attention."
  },
  {
    "id": 5,
    "characterization": "Lab Expansion & Consolidation",
    "blurb": "Facility changes or space constraints are creating planning and operational pressures."
  },
  {
    "id": 6,
    "characterization": "Goal Alignment",
    "blurb": "Goals, scope, and resources are not fully aligned for execution."
  },
  {
    "id": 7,
    "characterization": "Technology Readiness/Adoption",
    "blurb": "Readiness to adopt and embed new technologies requires reinforcement."
  },
  {
    "id": 8,
    "characterization": "Patient Centric",
    "blurb": "Patient-impact outcomes are a priority area for improvement."
  },
  {
    "id": 9,
    "characterization": "Connected with Clinical (AMS/ID)",
    "blurb": "Coordination with clinical/AMS teams needs strengthening across the order-to-result pathway."
  }
]